import React from "react"
import PropTypes from "prop-types"
import PaymentMethodOption from "./payment_method_option"
import RegistrationsPropTypes from "utils/prop_types"

class PaymentMethodSelect extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    paymentMethods: PropTypes.arrayOf(RegistrationsPropTypes.PaymentMethod).isRequired,
    selectedPaymentMethod: RegistrationsPropTypes.PaymentMethod.isRequired
  }

  render() {
    const { onChange, paymentMethods, selectedPaymentMethod } = this.props

    return (
      <div>
        <label className="label h3 pb-2">Select payment method</label>
        <div className="mb-3">
          {paymentMethods.map(paymentMethod => (
            <PaymentMethodOption
              key={paymentMethod.id}
              onChange={() => onChange(paymentMethod)}
              paymentMethod={paymentMethod}
              selected={selectedPaymentMethod === paymentMethod}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default PaymentMethodSelect
